<script lang="ts">
    import type { VideoBlockFragment } from '$gen/graphql';

    export let block: VideoBlockFragment;
    $: video = block?.video[0]?.__typename === 'assets_Asset' ? block.video[0] : null;
</script>

{#if video?.kind === 'video'}
    <section
        class=" grid max-h-[80vh] w-full max-w-full place-content-center outline-dashed outline-red"
    >
        <video
            class="h-full max-h-full w-auto overflow-hidden"
            style:aspect-ratio={video.width / video.height}
            src={video.url}
            alt={video.title}
            width={video.width}
            height={video.height}
            muted
            autoplay
            loop
        />
    </section>
{:else if video?.kind === 'json'}
    <section class="max-h-[80vh]">
        {@html video.embeddedAsset.html}
    </section>
{/if}

<style lang="scss">
    section {
        :global(iframe) {
            width: 100%;
            aspect-ratio: 16/9;
            height: min-content;
            max-height: 100%;
        }
    }
</style>
